export enum HMSStreamingState {
  NONE = 'NONE',
  STARTING = 'STARTING',
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
  FAILED = 'FAILED',
}
